export default "__VITE_ASSET__YiE27jJz__"